import React from "react";

// ── Flip wrapper ───────────────────────────────────────────────────────────────
export const TiltCard = ({ children }) => (
  <div className="group" style={{ perspective: "1000px" }}>
    <div
      style={{
        transition: "transform 0.7s cubic-bezier(0.4,0.2,0.2,1)",
        transformStyle: "preserve-3d",
      }}
      className="relative w-full group-hover:[transform:rotateY(180deg)]"
    >
      {children}
    </div>
  </div>
);

// ── Shared SVG parts ───────────────────────────────────────────────────────────
const Chip = ({ fill1, fill2, stroke }) => (
  <g>
    <rect width="46" height="36" rx="5" fill={fill1} />
    <rect x="1.5" y="1.5" width="43" height="33" rx="4" fill="none" stroke={stroke} strokeWidth="0.8" />
    <line x1="0" y1="12" x2="46" y2="12" stroke={stroke} strokeWidth="0.7" />
    <line x1="0" y1="24" x2="46" y2="24" stroke={stroke} strokeWidth="0.7" />
    <line x1="16" y1="0" x2="16" y2="36" stroke={stroke} strokeWidth="0.7" />
    <line x1="30" y1="0" x2="30" y2="36" stroke={stroke} strokeWidth="0.7" />
    <rect x="5" y="5" width="36" height="26" rx="2" fill={fill2} fillOpacity="0.4" stroke={stroke} strokeWidth="0.4" />
  </g>
);

const NFC = ({ color }) => (
  <g fill="none" stroke={color} strokeWidth="1.8" opacity="0.6" strokeLinecap="round">
    <path d="M0,14 A13,13 0 0,1 13,0" />
    <path d="M3,14 A10,10 0 0,1 10,1" />
    <circle cx="0" cy="15" r="2" fill={color} stroke="none" />
  </g>
);

// ── Card face/back shared layout ───────────────────────────────────────────────
const CardFace = ({ children, style, backface = false }) => (
  <div
    className="w-full rounded-xl overflow-hidden"
    style={{
      backfaceVisibility: "hidden",
      WebkitBackfaceVisibility: "hidden",
      ...(backface ? { transform: "rotateY(180deg)", position: "absolute", top: 0, left: 0 } : {}),
      ...style,
    }}
  >
    {children}
  </div>
);

// ── GOLD Card ──────────────────────────────────────────────────────────────────
export const GoldCard = () => (
  <>
    {/* Front */}
    <CardFace style={{ boxShadow: "0 8px 28px rgba(0,0,0,0.4)" }}>
      <svg viewBox="0 0 380 240" xmlns="http://www.w3.org/2000/svg" className="w-full block">
        <defs>
          <linearGradient id="gf-bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#3d1205" />
            <stop offset="50%" stopColor="#6b2d0e" />
            <stop offset="100%" stopColor="#b8870a" />
          </linearGradient>
          <linearGradient id="gf-chip" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#b8920e" />
            <stop offset="100%" stopColor="#7a5c0a" />
          </linearGradient>
          <clipPath id="gf-clip"><rect width="380" height="240" rx="14" /></clipPath>
        </defs>
        <rect width="380" height="240" rx="14" fill="url(#gf-bg)" />
        <text x="195" y="215" fontFamily="Georgia,serif" fontSize="220" fontWeight="900" fill="#b8920e" fillOpacity="0.05" clipPath="url(#gf-clip)">C</text>
        <rect x="0" y="0" width="380" height="2" fill="#b8920e" fillOpacity="0.5" />
        <rect x="0" y="0" width="2" height="240" fill="#b8920e" fillOpacity="0.5" />
        <text x="28" y="50" fontFamily="Georgia,serif" fontSize="32" fontWeight="900" fill="white" letterSpacing="-1">CORSA</text>
        <text x="30" y="64" fontFamily="Arial,sans-serif" fontSize="8" fill="#b8920e" letterSpacing="5">EXCHANGE</text>
        <g transform="translate(28,82)"><Chip fill1="url(#gf-chip)" fill2="#b8920e" stroke="#7a5c0a" /></g>
        <text x="28" y="228" fontFamily="Arial,sans-serif" fontSize="7.5" fill="white" fillOpacity="0.4" letterSpacing="2">500 - 2.999 PUNCTE</text>
      </svg>
    </CardFace>

    {/* Back */}
    <CardFace backface style={{ boxShadow: "0 20px 50px rgba(184,135,10,0.3)" }}>
      <svg viewBox="0 0 380 240" xmlns="http://www.w3.org/2000/svg" className="w-full block">
        <defs>
          <linearGradient id="gb-bg" x1="1" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#3d1205" />
            <stop offset="50%" stopColor="#6b2d0e" />
            <stop offset="100%" stopColor="#b8870a" />
          </linearGradient>
        </defs>
        <rect width="380" height="240" rx="14" fill="url(#gb-bg)" />
        <g opacity="0.07">
          <circle cx="190" cy="120" r="130" fill="none" stroke="#f5d27a" strokeWidth="1" />
          <circle cx="190" cy="120" r="90" fill="none" stroke="#f5d27a" strokeWidth="0.6" />
        </g>
        <text x="190" y="88" fontFamily="Georgia,serif" fontSize="13" fill="#f5d27a" fillOpacity="0.5" textAnchor="middle" letterSpacing="4">MULTUMIM</text>
        <text x="190" y="122" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="white" fillOpacity="0.92" textAnchor="middle" letterSpacing="-0.5">Iti apreciem</text>
        <text x="190" y="148" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="white" fillOpacity="0.92" textAnchor="middle" letterSpacing="-0.5">increderea.</text>
        <text x="190" y="185" fontFamily="Arial,sans-serif" fontSize="8" fill="white" fillOpacity="0.35" textAnchor="middle" letterSpacing="1">Membru Corsa Exchange Gold</text>
        <text x="24" y="228" fontFamily="Arial,sans-serif" fontSize="7" fill="white" fillOpacity="0.3" letterSpacing="1">CORSAEXCHANGE.RO</text>
        <rect x="0" y="237" width="380" height="3" fill="#d4a017" fillOpacity="0.5" />
      </svg>
    </CardFace>
  </>
);

// ── BLACK Card ─────────────────────────────────────────────────────────────────
export const BlackCard = () => (
  <>
    {/* Front */}
    <CardFace style={{ boxShadow: "0 8px 28px rgba(0,0,0,0.5)" }}>
      <svg viewBox="0 0 380 240" xmlns="http://www.w3.org/2000/svg" className="w-full block">
        <defs>
          <linearGradient id="bf-bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#080808" />
            <stop offset="55%" stopColor="#140804" />
            <stop offset="100%" stopColor="#1e0e0a" />
          </linearGradient>
          <linearGradient id="bf-chip" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#383838" />
            <stop offset="100%" stopColor="#181818" />
          </linearGradient>
          <clipPath id="bf-clip"><rect width="380" height="240" rx="14" /></clipPath>
        </defs>
        <rect width="380" height="240" rx="14" fill="url(#bf-bg)" />
        <text x="195" y="215" fontFamily="Georgia,serif" fontSize="220" fontWeight="900" fill="#c94030" fillOpacity="0.07" clipPath="url(#bf-clip)">C</text>
        <rect x="0" y="0" width="380" height="2" fill="#c94030" fillOpacity="0.65" />
        <rect x="0" y="0" width="2" height="240" fill="#c94030" fillOpacity="0.65" />
        <text x="28" y="50" fontFamily="Georgia,serif" fontSize="32" fontWeight="900" fill="white" letterSpacing="-1">CORSA</text>
        <text x="30" y="64" fontFamily="Arial,sans-serif" fontSize="8" fill="#c94030" letterSpacing="5">EXCHANGE</text>
        <g transform="translate(28,82)"><Chip fill1="url(#bf-chip)" fill2="#444" stroke="#333" /></g>
        <text x="28" y="228" fontFamily="Arial,sans-serif" fontSize="7.5" fill="white" fillOpacity="0.35" letterSpacing="2">3.000+ PUNCTE</text>
      </svg>
    </CardFace>

    {/* Back */}
    <CardFace backface style={{ boxShadow: "0 20px 50px rgba(0,0,0,0.6)" }}>
      <svg viewBox="0 0 380 240" xmlns="http://www.w3.org/2000/svg" className="w-full block">
        <defs>
          <linearGradient id="bb-bg" x1="1" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#080808" />
            <stop offset="55%" stopColor="#140804" />
            <stop offset="100%" stopColor="#1e0e0a" />
          </linearGradient>
        </defs>
        <rect width="380" height="240" rx="14" fill="url(#bb-bg)" />
        <g opacity="0.12">
          <circle cx="190" cy="120" r="130" fill="none" stroke="#e05540" strokeWidth="1" />
          <circle cx="190" cy="120" r="90" fill="none" stroke="#e05540" strokeWidth="0.6" />
        </g>
        <text x="190" y="88" fontFamily="Georgia,serif" fontSize="13" fill="#e05540" fillOpacity="0.6" textAnchor="middle" letterSpacing="4">MULTUMIM</text>
        <text x="190" y="122" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="white" fillOpacity="0.92" textAnchor="middle" letterSpacing="-0.5">Iti apreciem</text>
        <text x="190" y="148" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="white" fillOpacity="0.92" textAnchor="middle" letterSpacing="-0.5">loialitatea.</text>
        <text x="190" y="185" fontFamily="Arial,sans-serif" fontSize="8" fill="white" fillOpacity="0.3" textAnchor="middle" letterSpacing="1">Membru Corsa Exchange Black</text>
        <text x="24" y="228" fontFamily="Arial,sans-serif" fontSize="7" fill="white" fillOpacity="0.25" letterSpacing="1">CORSAEXCHANGE.RO</text>
        <rect x="0" y="237" width="380" height="3" fill="#e05540" fillOpacity="0.4" />
      </svg>
    </CardFace>
  </>
);